"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useGetProductShades = require("./useGetProductShades");
Object.keys(_useGetProductShades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetProductShades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetProductShades[key];
    }
  });
});
//# sourceMappingURL=index.js.map